import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { AlertBanner } from './index';

export const EmailVerificationBanner: React.FC = () => {
  const { user, isEmailVerified, resendVerification } = useAuth();
  const { t } = useLanguage();
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  if (isEmailVerified || !user) {
    return null;
  }

  const handleResend = async () => {
    setIsLoading(true);
    setErrorMsg(null);
    try {
      await resendVerification();
      setIsSent(true);
    } catch (err: any) {
      setErrorMsg(err?.message || 'Failed to resend verification email.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isSent) {
    return (
      <div className="mb-6 p-3.5 bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-300 dark:border-emerald-800 rounded-xl flex items-center justify-between text-xs text-emerald-800 dark:text-emerald-200">
        <div className="flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600 dark:text-emerald-400 shrink-0" />
          <span>{t('email.sent')} <strong>{user.email}</strong></span>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6">
      <AlertBanner
        variant="warning"
        title={t('email.required')}
        message={t('email.verifyNotice')}
        action={{
          label: t('email.resend'),
          onClick: handleResend,
          isLoading,
        }}
      />
      {errorMsg && (
        <p className="mt-1 text-xs text-rose-600 dark:text-rose-400">{errorMsg}</p>
      )}
    </div>
  );
};
